import { registerWebserverToken } from '../shared/xomics-webserver-client';

// An anonymous browser credential, kept for 180 days like the G-VEP one. The
// backend hashes it and scopes every ProteoRisk job read to it.
const COOKIE_NAME = 'proteorisk-cookie';
const LIFETIME_MS = 180 * 24 * 60 * 60 * 1000;

function parseCookies() {
  return Object.fromEntries(document.cookie.split(';').map((cookie) => {
    const [key, ...value] = cookie.trim().split('=');
    return [key, value.join('=')];
  }));
}

function getCookie() {
  const value = parseCookies()[COOKIE_NAME];
  if (!value) return null;
  const [id, expiry] = value.split('|');
  if (!id) return null;
  return { id, expiry: parseInt(expiry, 10) };
}

function setCookie(id, expiryMs) {
  document.cookie = `${COOKIE_NAME}=${id}|${expiryMs}; path=/; expires=${new Date(expiryMs).toUTCString()}; samesite=strict`;
}

export async function ensureProteoRiskCookie() {
  const existing = getCookie();
  if (existing) {
    await registerWebserverToken(existing.id);
    return existing;
  }
  const id = crypto.randomUUID();
  const expiry = Date.now() + LIFETIME_MS;
  setCookie(id, expiry);
  await registerWebserverToken(id);
  return { id, expiry };
}

export function getCookieDaysLeft() {
  const cookie = getCookie();
  if (!cookie || !Number.isFinite(cookie.expiry)) return 0;
  return Math.max(0, Math.ceil((cookie.expiry - Date.now()) / (24 * 60 * 60 * 1000)));
}
